export { RichTextBlock } from './richTextBlock'
export { default as richTextBlockFactory } from './richTextBlockFactory'
